import { TFunction } from 'i18next';

import { getNameExtension } from '@shared/helpers';

import { getValidatedFormats } from './getValidatedFormats';
import { isNotValidateSize } from './isNotValidateSize';

interface IErrorHandleMiddlewareParams {
    onAddFiles: (files: File[]) => void;
    onErrorCb?: (textError: string) => void;
    errorsText?: {
        FORMAT: string;
        SIZE: string;
        COUNT: string;
        ONE_FILE_COUNT: string;
    };
    alreadyAttachedLength?: number;
    maxAttachmentSizeInMb?: number;
    maxOverallSizeInMb?: number;
    t: TFunction<'translation', undefined>;
    replaceUploadFormats?: string[];
    maxFiles?: number;
    multiple?: boolean;
    validateExtensions?: string[];
}

const Errors = {
    // @ts-ignore
    // FORMAT: i18next.t('useGenerateMeasurementModal.errorsText.FORMAT'),
    // @ts-ignore
    FORMAT: i18next.t('Tasks.ModalFileUploader.useUploadFile.FormatError.text'),
    // @ts-ignore
    SINGLE_FORMAT: i18next.t('Attachment.errorHandle.Format.SingleFormat.text'),
    // @ts-ignore
    SIZE: i18next.t('Tasks.ModalFileUploader.useUploadFile.SizeError.text'),
    // @ts-ignore
    COUNT: i18next.t('Tasks.ModalFileUploader.useUploadFile.CountError.text'),
    // @ts-ignore
    COUNT: i18next.t('Tasks.ModalFileUploader.useUploadFile.CountError.text'),
    // @ts-ignore
    NON_MULTIPLE_COUNT: i18next.t('Attachment.errorHandle.Count.NonMultiple.text'),
    // @ts-ignore
    ONE_FILE_COUNT: i18next.t('Tasks.ModalFileUploader.useUploadFile.OneFileCountError.text'),
};

export const errorHandleMiddleware = (params: IErrorHandleMiddlewareParams) => {
    const validatedFormatData =
        params.validateExtensions ||
        getValidatedFormats({
            replaceWithFormats: params?.replaceUploadFormats ?? [],
        });
    const {
        t,
        alreadyAttachedLength = 0,
        onAddFiles,
        onErrorCb,
        errorsText,
        maxAttachmentSizeInMb = 500,
        maxOverallSizeInMb = 500,
        maxFiles = 10,
        multiple = true,
    } = params;

    return (files: File[]) => {
        const uploadFileList = [];
        let overallSize = 0;
        if (!multiple && files.length > 1) {
            // @ts-ignore
            swal({
                text: Errors.NON_MULTIPLE_COUNT,
                cancel: false,
                confirm: true,
                button: {
                    text: t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }
        if (alreadyAttachedLength + files.length > maxFiles) {
            // @ts-ignore
            swal({
                text: Errors.COUNT,
                cancel: false,
                confirm: true,
                button: {
                    text: t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }
        if (files.length > maxFiles) {
            // @ts-ignore
            swal({
                text: Errors.COUNT,
                cancel: false,
                confirm: true,
                button: {
                    text: t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }

        for (let i = 0; i < files.length; i += 1) {
            const { extension } = getNameExtension(files[i].name);
            if (!validatedFormatData.includes(extension.toLowerCase())) {
                // @ts-ignore
                swal({
                    text: multiple ? Errors.FORMAT : Errors.SINGLE_FORMAT,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: t('button.got_it.text'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return;
            }

            const checkValidate = isNotValidateSize(files[i].size, maxAttachmentSizeInMb);

            if (checkValidate) {
                // @ts-ignore
                swal({
                    text: Errors.SIZE,
                    cancel: false,
                    confirm: true,
                    button: {
                        text: t('button.got_it.text'),
                        value: true,
                        visible: true,
                        className: 'btn btn-secondary',
                    },
                });
                return;
            }
            uploadFileList.push(files[i]);

            overallSize += files[i].size;
        }

        const isOverallSize = isNotValidateSize(overallSize, maxOverallSizeInMb);

        if (isOverallSize) {
            // @ts-ignore
            swal({
                text: Errors.SIZE,
                cancel: false,
                confirm: true,
                button: {
                    text: t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return;
        }
        if (files.length > 1 && !multiple) {
            onErrorCb
                ? onErrorCb(errorsText ? errorsText.ONE_FILE_COUNT : Errors.ONE_FILE_COUNT)
                : // @ts-ignore
                  swal({
                      text: Errors.ONE_FILE_COUNT,
                      cancel: false,
                      confirm: true,
                      button: {
                          text: t('button.got_it.text'),
                          value: true,
                          visible: true,
                          className: 'btn btn-secondary',
                      },
                  });
            return;
        }

        const checkValidate = isNotValidateSize(files[0].size, maxAttachmentSizeInMb);

        if (checkValidate) {
            onErrorCb
                ? onErrorCb(errorsText ? errorsText.SIZE : Errors.SIZE)
                : // @ts-ignore
                  swal({
                      text: Errors.SIZE,
                      cancel: false,
                      confirm: true,
                      button: {
                          text: t('button.got_it.text'),
                          value: true,
                          visible: true,
                          className: 'btn btn-secondary',
                      },
                  });
            return;
        }

        const { extension } = getNameExtension(files[0].name);

        // TO_TEST ПРОВЕРИТЬ В ГЕНЕРАЦИИ ОБМЕРАХ ИЗ-ЗА ЭТОГО ФИКСА
        const isValidExtension = validatedFormatData.includes(extension.toLowerCase());

        if (!isValidExtension) {
            onErrorCb
                ? onErrorCb(errorsText ? errorsText.FORMAT : Errors.FORMAT)
                : // @ts-ignore
                  swal({
                      text: Errors.FORMAT,
                      cancel: false,
                      confirm: true,
                      button: {
                          text: t('button.got_it.text'),
                          value: true,
                          visible: true,
                          className: 'btn btn-secondary',
                      },
                  });
            return;
        }

        onAddFiles(files);
    };
};
